import React from 'react';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { FilterDetailsPicker } from './filter-details-picker';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { endpoints } from 'app/area/import-mappings/endpoints';
import { ImportMappingsTranslation, referenceCodetableId } from 'app/area/import-mappings/constants';
import { CodeFieldWireKey, CodetableMetadata, ImportMappingsOptions } from 'app/area/import-mappings/types-store';
import { FilterDetailsCategoryPicker } from 'app/area/import-mappings/list-items/components/filter-details-category-picker';
import { LoadCodeItemsParams } from 'app/area/import-mappings/types';

interface LinkCodesDetailsProps {
  metadata: CodetableMetadata;
  codetable: ComplexValue<number>;
  importSet: ComplexValue<number>;
  category: ComplexValue<number>;
  options: ImportMappingsOptions;
  shouldPrompt: boolean;
  translation: ImportMappingsTranslation;
  loadCodetableOptions: (
    id: string,
    codetableId: number,
    loadOptionsParams: LoadOptions,
    optionsParams?: LoadCodeItemsParams
  ) => void;
  updateCodetable: (value: ComplexValue<number>) => void;
  updateCategory: (value: ComplexValue<number>) => void;
  updateImportSet: (value: ComplexValue<number>) => void;
}

export const FiltersDetails: React.FC<LinkCodesDetailsProps> = ({
  metadata, codetable, category, importSet, shouldPrompt, translation,
  options, loadCodetableOptions, updateCodetable, updateImportSet, updateCategory
}) => {

  return <>
    <div className="row">
      <FilterDetailsPicker
        componentId={'importSetId'}
        endpoint={endpoints.importSetOptions}
        label={translation.import_set}
        shouldPrompt={shouldPrompt}
        valueItem={importSet}
        onChange={updateImportSet}
        translation={translation}
        validation={undefined} />
    </div>
    <div className="row">
      <FilterDetailsPicker
        componentId={'codetableId'}
        label={translation.codetable}
        endpoint={endpoints.codetableOptions}
        shouldPrompt={shouldPrompt}
        valueItem={codetable}
        onChange={updateCodetable}
        optionsParams={{ excludeCodetablesWithoutSubset: true }}
        translation={translation} />
      {isDefinedIncludingZero(metadata?.codetableCategory?.id)
        && codetable?.value !== referenceCodetableId
        && <FilterDetailsCategoryPicker
          componentId={'categoryId'}
          label={metadata?.codetableCategory?.label ?? translation.category}
          shouldPrompt={shouldPrompt}
          valueItem={category}
          codetableId={metadata?.codetableCategory?.id}
          options={options}
          loadOptionsParams={{ displayNotSelected: true }}
          optionsParams={{ limitFieldsTo: [CodeFieldWireKey.code] }}
          loadCodetableOptions={loadCodetableOptions}
          onChange={updateCategory}
          translation={translation}
        />}
    </div>
  </>;
};
